import { computed, unref } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import fetchData from '@/util/fetch'
import { hasPermission } from '@/logic/common/Permissions'

export const CASES_PERMISSION = 'Tickets:view_cases'

// The cases of an address (tickets location id, 1234AB12-A), newest first. Shared by the cases tab
// and its count in the tab header: same query key, so one request.
export function useAddressCases(locationId) {
  const canViewCases = hasPermission([CASES_PERMISSION])
  return useQuery({
    queryKey: computed(() => ['callCentreCases', unref(locationId)]),
    queryFn: async () => {
      const params = new URLSearchParams({ location_id: unref(locationId), limit: '100' })
      const result = await fetchData(`/tickets/api/v1/cases?${params}`)
      return result?.status === 'OK' ? result.data : []
    },
    enabled: computed(() => canViewCases && !!unref(locationId)),
    refetchOnWindowFocus: false,
  })
}
